<!-- Instructions (same style/wording as your sample) -->
<div class="max-w-xl mb-3">
	<ul class="list-disc pl-5 mb-2 text-sm">
		<li class="pb-3">
			Summarises your details, Groups and Roles Assigned.
		</li>
		<li class="pb-3">
			For guidance on using Tyalls and understanding access, visit the
			<a href="{{this.supportHubLink}}" target="blank" class="underline cursor-pointer">Support Hub</a>
		</li>
	</ul>
</div>

<div class="tyalls-table-name mb-3">
	<h6 class="tyalls-table-heading">
		User Access
		<span class="font-light"> - {{ property()?.name }}</span>
	</h6>
</div>

<div class="panel">
	<div>
		<div class="field">
			<div class="label">Name:</div>
			<div class="box wide">{{ userDisplayName() || (isLoading() ? 'Loading…' : '—') }}</div>
		</div>

		<div class="field">
			<div class="label">Account Owner(s):</div>
			<div class="box owner-name">{{ accountOwnerNames() || '—' }}</div>
		</div>
	</div>

	<div class="divider"></div>
	<div class="two-col">
		<div class="col">
			<div class="col-title">Assigned Group/s:</div>
			<div class="list-box">
				<ng-container *ngIf="!isLoading(); else loadingGroups">
					<div *ngIf="myGroups()?.length; else noGroups" class="list">
						<div *ngFor="let g of myGroups(); trackBy: trackById" class="list-item">
							{{ g.displayName || g.name }}
						</div>
					</div>
				</ng-container>
				<ng-template #loadingGroups><div class="placeholder">Loading…</div></ng-template>
				<ng-template #noGroups><div class="placeholder">No groups</div></ng-template>
			</div>
		</div>

		<div class="col">
			<div class="col-title">Assigned Role/s:</div>
			<div class="list-box">
				<ng-container *ngIf="!isLoading(); else loadingRoles">
					<div *ngIf="myRoles()?.length; else noRoles" class="list">
						<div *ngFor="let r of myRoles(); trackBy: trackById" class="list-item">
							{{ r.name | roleLabel }}
						</div>
					</div>
				</ng-container>
				<ng-template #loadingRoles><div class="placeholder">Loading…</div></ng-template>
				<ng-template #noRoles><div class="placeholder">No roles</div></ng-template>
			</div>
		</div>
	</div>

	<div class="actions">
		<button class="link-btn" (click)="refresh()">Refresh</button>
	</div>
</div>
